import styled from "styled-components";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { rem } from "polished";
import colors from "../../utils/colors";
import { Localize } from "../../locale/localization";
import TweenLite from "gsap";
import { EASE } from "../../utils/easing";

const Container = styled.div`
  position: absolute;
  color: ${colors.WHITE};
  text-align: center;
  margin: 0 auto;
  font-size: ${rem("49px")};
  width: 100%;
  top: 40%;
  left: 5%;

  .bottom {
    display: block;
    font-size: ${rem("18px")};
    padding-top: ${rem("10px")};
  }

  &.tight {
    font-size: ${rem("22px")};
    .bottom {
      font-size: ${rem("12px")};
      padding-top: 0;
    }
  }
`;

class ScoreNumber extends Component {
  tweenObj = {
    score: 0
  };

  componentWillReceiveProps(nextProps) {
    //console.log('ScoreNumber willReceiveProps', nextProps);
    this.updateValue(nextProps.score, false);
  }

  componentDidMount() {
    this.updateValue(this.props.score, true);
  }

  componentWillUnmount() {
    TweenLite.killTweensOf(this.tweenObj);
  }

  updateValue(score, animate) {
    const time = animate ? 0 : 3;
    TweenLite.to(this.tweenObj, time, {
      score: score,
      roundProps: "score",
      onUpdate: this.onTweenUpdate,
      ease: EASE.easeOutExpo
    });
  }

  onTweenUpdate = () => {
    if (this.scoreElem) {
      this.scoreElem.innerHTML = this.tweenObj.score;
    }
  };

  render() {
    return (
      <Container className={this.props.tight && "tight"}>
        <span ref={r => (this.scoreElem = r)} />
        <span className="bottom">{Localize("score")}</span>
      </Container>
    );
  }
}

ScoreNumber.propTypes = {
  score: PropTypes.number
};

ScoreNumber.defaultProps = {
  score: 0
};

export default ScoreNumber;



// WEBPACK FOOTER //
// ./src/ui/score/ScoreNumber.js